import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        {/* <h1 className="footer__title">Alex Casella 2023</h1> */}

        {/* <ul className="footer__list">
          <li>
            <a href="#about" className="footer__link">
              About
            </a>
          </li>

          <li>
            <a href="#portfolio" className="footer__link">
              Projects
            </a>
          </li>

          <li>
            <a href="#testimonials" className="footer__link">
              Testimonials
            </a>
          </li>
        </ul> */}

        <div className="footer__social">
          <a
            href="https://www.linkedin.com/in/axcasella/"
            className="footer__social-link"
            target="_blank" rel="noreferrer"
          >
            <i className="bx bxl-linkedin"></i>
          </a>
        </div>

        <span className="footer__copy">
          &#169; Alex Casella 2026. All rights reserved
        </span>
      </div>
    </footer>
  );
};

export default Footer;
